// extracted by mini-css-extract-plugin
export default {"shareContainer":"ShareButtons_shareContainer__hAMrk"};